import { RefObject } from 'react'

export const scrollBottom = (ref: RefObject<HTMLElement>) => {
  if (!ref.current) return;
  
  ref.current.scrollTo({
    behavior: 'auto',
    top: ref.current.scrollHeight,
  })
}
